package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class NoticeResponse(
    @SerialName("school_id") val schoolId: String? = null,
    val title: String? = null,
    val content: String? = null,
    @SerialName("notice_id") val noticeId: String? = null,
    val audience: String? = null,
    @SerialName("class_targets") val classTargets: List<String>? = null,
    @SerialName("expires_at") val expiresAt: String? = null,
    val status: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    val id: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("created_by_name") val createdByName: String? = null,
    @SerialName("updated_by_name") val updatedByName: String? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String>? = null,
    @SerialName("attachment_file_urls") val attachmentFileUrls: List<String>? = null
)

@Serializable
data class TeacherNoticeStatisticsResponse(
    @SerialName("teacher_id") val teacherId: String? = null,
    @SerialName("teacher_name") val teacherName: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("academic_year_label") val academicYearLabel: String? = null,
    @SerialName("academic_year_start") val academicYearStart: String? = null,
    @SerialName("academic_year_end") val academicYearEnd: String? = null,
    val counters: Map<String, Int> = emptyMap()
)
